(function(){
  let mediaSwiper = {};
  let popupSwiper = {};
  const html = document.documentElement;
  let addToCartController = null;
  
  // shopify formate money function
  const moneyFormat = '${{amount}}';
  function formatMoney$1(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    
    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ',',
      decimal = '.'
    ) {
        if (isNaN(number) || number == null) {
          return 0;
        }
      
        number = (number / 100.0).toFixed(precision);
      
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';
      
        return dollarsAmount + centsAmount;
      }
    
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    
    return formatString.replace(placeholderRegex, value);
  }
  var formatMoney = (val => formatMoney$1(val, window.routes.money_format || "${{amount}}"));
  
  // Debounce function
  function debounce(func, delay) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, delay);
    };
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest(
      `form[action="${window.routes.cart_add_url}"]`
    );

    if (!form) return;

    event.preventDefault();

    if (form.dataset.loading === 'true') return;
    form.dataset.loading = 'true';

    if (addToCartController) {
      addToCartController.abort();
    }

    addToCartController = new AbortController();

    const loader = form.querySelector('[data-add-to-cart] .button__loader');
    const span = form.querySelector('[data-add-to-cart] .product-form-btn__text');
    const button = form.querySelector('[data-add-to-cart]');
    
    loader?.classList.remove('hidden');
    span?.classList.add('hidden');
    button?.setAttribute('disabled', 'disabled');

    try {
      // 1️⃣ Add item
      await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        signal: addToCartController.signal
      });

      // 2️⃣ Update drawer HTML
      await updateCartDrawerGlobal();

      // 3️⃣ Get fresh cart data
      const res = await fetch('/cart.js');
      const cartData = await res.json();

      // 4️⃣ Update UI state
      cartItemCount(cartData);
      updateCartDrawerState(cartData);

      // 5️⃣ Open drawer
      openCartDrawerGlobal();

    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error(err);
      }
    } finally {
      form.dataset.loading = 'false';
      loader?.classList.add('hidden');
      span?.classList.remove('hidden');
      button?.removeAttribute('disabled');
    }
  });

  async function updateCartDrawerGlobal() {
    const res = await fetch('/?section_id=custom-cart-drawer');
    const text = await res.text();
    const html = document.createElement('div');
    html.innerHTML = text;

    const newBox = html.querySelector('[data-cart]')?.innerHTML;
    const cartDrawerContent = document.querySelector('[data-cart]');

    if (cartDrawerContent && newBox) {
      cartDrawerContent.innerHTML = newBox;
      const newCloseBtn = cartDrawerContent.querySelector('.drawer__close-icon');
      if(newCloseBtn) {
        newCloseBtn.addEventListener('click', () => {
          closeCartDrawerGlobal();
        });
      }
      initCartForm();
      showMoreProducts();
      cartCountdownEvents();
    }
  }

  function openCartDrawerGlobal() {
    document.querySelectorAll('.cart-drawer').forEach(drawer => {
      drawer.classList.add('active');
    });
    document.querySelector('.cart-drawer__overlay')?.classList.add('active');
    document.documentElement.classList.add('lock');
  }

  function closeCartDrawerGlobal() {
    document.querySelectorAll('.cart-drawer').forEach(drawer => {
      drawer.classList.remove('active');
    });
    document.querySelector('.cart-drawer__overlay')?.classList.remove('active');
    document.documentElement.classList.remove('lock');
  }

  function updateCartDrawerState(cartData) {
    const cartDrawer = document.querySelectorAll('.cart-drawer');
    if (cartData.item_count === 0) {
      cartDrawer.forEach(drawer => {
        if (drawer) {
          drawer.classList.add('empty-cart__drawer');
        }
      });
    } else {
      cartDrawer.forEach(drawer => {
        if (drawer) {
          drawer.classList.remove('empty-cart__drawer');
        }
      });
    }
  }
  function cartItemCount(cartData) {
    const cartItemCounter = document.querySelectorAll('[data-cart-count]');
    const cartTotal = document.querySelectorAll('[data-subtotal]');
    cartItemCounter.forEach(counter => {
      if (!counter) {
        return;
      }
      if (cartData.item_count > 0) {
        counter.textContent = cartData.item_count;
        counter.classList.remove('hidden');
      } else {
        counter.remove();
      }
    });
    cartTotal.forEach(total => {
      if (total) {
        total.textContent = formatMoney(cartData.total_price);
      }
    });
  }


  function initTransparentHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    const transparentHeader = header.getAttribute('data-transparent-header');
    const isHome = window.location.pathname === window.rootUrl;

    if (transparentHeader === 'true') {
      function updateTransparentHeader() {
        if (window.scrollY === 0) {
          header.classList.remove("header__transparent--sticky");
        } else {
          header.classList.add("header__transparent--sticky");
        }
      }

      const debouncedAddSticky = debounce(updateTransparentHeader, 50);
      window.addEventListener("scroll", debouncedAddSticky);

      updateTransparentHeader();
    }
  }

  function reviewsCounter() {
    const counters = document.querySelectorAll(".impact-text__text");
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseInt(el.dataset.counter.replace(/,/g, ''), 10);
          const duration = 1500; // 1.5 seconds
          const start = 0;
          const frameRate = 60;
          const totalFrames = Math.round(duration / (1000 / frameRate));
          let frame = 0;
  
          const countUp = el.querySelector(".count-up");
  
          const counter = setInterval(() => {
            frame++;
            const progress = frame / totalFrames;
            const value = Math.floor(progress * target);
  
            countUp.textContent = value.toLocaleString(); // Add commas
            
            if (frame === totalFrames) {
              clearInterval(counter);
              countUp.textContent = target.toLocaleString();
            }
          }, 1000 / frameRate);
  
          el.classList.add("visible");
          obs.unobserve(el); // Run only once
        }
      });
    }, {
      threshold: 0.5
    });
  
    counters.forEach(counter => observer.observe(counter));
  }
  function featureCollectionSlider() {
    const sliderWrapper = document.querySelectorAll('.feature-collection__container');
    sliderWrapper.forEach(wrapper => {
      if (wrapper) {
        const id = wrapper.dataset.sectionId;
        const slidesToShow = wrapper.dataset.slidesToShow;
        const container = wrapper.querySelector('#slider-'+ id);
        const nextElement = wrapper.querySelector('.feature__next-button');
        const prevElement = wrapper.querySelector('.feature__prev-button');
        const scrollBar = wrapper.querySelector('.swiper-scrollbar');
        if (container) {
          if (container.swiper) {
            container.swiper.destroy();
          }
    
          let swiperOptions = {
            effect: "slide",
            grabCursor: true,
            slidesPerView: 1.2,
            spaceBetween: 24,
            speed: 1000,
            navigation: {
              nextEl: nextElement,
              prevEl: prevElement,
            },
            scrollbar: {
              el: scrollBar,
              hide: true,
            },
            breakpoints: {
              700: {
                slidesPerView: Math.min(2.2, slidesToShow),
              },
              1000: {
                slidesPerView: slidesToShow,
              },
            },
          };
          let swiper = new Swiper(container, swiperOptions);
        }
      }
    });
  }
  function collectionListSlider() {
    const sliderWrapper = document.querySelectorAll('.collection-list__container');
    sliderWrapper.forEach(wrapper => {
      if (wrapper) {
        const id = wrapper.dataset.sectionId;
        const itemsToShow = wrapper.dataset.itemsToShow;
        const container = wrapper.querySelector('#slider-'+ id);
        const nextElement = wrapper.querySelector('.feature__next-button');
        const prevElement = wrapper.querySelector('.feature__prev-button');
        const scrollBar = wrapper.querySelector('.swiper-scrollbar');
        if (container) {
          if (container.swiper) {
            container.swiper.destroy();
          }
    
          let swiperOptions = {
            effect: "slide",
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 24,
            speed: 1000,
            navigation: {
              nextEl: nextElement,
              prevEl: prevElement,
            },
            scrollbar: {
              el: scrollBar,
              hide: true,
            },
            breakpoints: {
              700: {
                slidesPerView: Math.min(2.2, itemsToShow),
              },
              1000: {
                slidesPerView: itemsToShow,
              },
            },
          };
          let swiper = new Swiper(container, swiperOptions);
        }
      }
    });
  }
  function localizations() {
    const localeButtons = document.querySelectorAll('.locale__button, .variant__selects-button');
  
    localeButtons.forEach(button => {
      if (!button.dataset.localized) {
        const popover = button.closest('.relative').querySelector('.popover');
        const overlay = button.closest('.relative').querySelector('.overlay');
  
        button.addEventListener('click', (e) => {
          e.stopPropagation();
          const isMobile = window.innerWidth <= 915;
          const isOpen = button.getAttribute('aria-expanded') === 'true';
  
          closeAllPopovers();
  
          if (!isOpen) {
            button.setAttribute('aria-expanded', 'true');
            popover.classList.add('is-active');
            if (isMobile) {
              overlay?.classList.add('active');
              document.documentElement.classList.add('lock');
            }
          } else {
            button.setAttribute('aria-expanded', 'false');
            popover.classList.remove('is-active');
            if (isMobile) {
              overlay?.classList.remove('active');
              document.documentElement.classList.remove('lock');
            }
          }
        });
  
        if (overlay) {
          overlay.addEventListener('click', () => {
            closeAllPopovers();
          });
        }
  
        // Mark button to avoid duplicate listeners on resize
        button.dataset.localized = "true";
      }
    });
  
    document.addEventListener('click', () => {
      closeAllPopovers();
    });
  
    function closeAllPopovers() {
      document.querySelectorAll('.locale__button').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('.relative .popover').forEach(popover => {
        popover.classList.remove('is-active');
      });
      document.querySelectorAll('.relative .overlay').forEach(overlay => {
        overlay.classList.remove('active');
      });
      document.documentElement.classList.remove('lock');
      const cursor = document.getElementById("custom-cursor");
      if (cursor) cursor.classList.add("hidden");
    }
  }
  function customCursor() {
    const customCursor = document.getElementById("custom-cursor");
    const overlays = document.querySelectorAll(".overlay");
  
    if (!customCursor || overlays.length === 0) return;
  
    overlays.forEach((overlay) => {
      overlay.addEventListener("mouseenter", () => {
        customCursor.classList.remove("hidden");
      });
  
      overlay.addEventListener("mouseleave", () => {
        customCursor.classList.add("hidden");
      });
  
      overlay.addEventListener("mousemove", (e) => {
        customCursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
      });
    });
  }
  function headerNavigationDrawer() {
    // const hasSubMenuElement = document.querySelectorAll('.header-has__submenu');
    // const megaMenuElement = document.querySelectorAll('.header-has__mega-menu');
    const hasSubMenuElement = document.querySelectorAll('.has__submenu');
    const megaMenuElement = document.querySelectorAll('.mega-menu__item');
    const hamburgerIcon = document.querySelector('.header-hamburger__icon');
    const closeIcon = document.querySelector('.navigation__close');
    const navigationDrawer = document.querySelector('.navigation-drawer');
    const navigationOverlay = document.querySelector('.navigation-drawer .overlay');
    const transparentHeader = document.querySelector('[data-transparent-header]');
    const headerLogoHover = document.querySelector('[data-transparent-header] .header__logo-image');
    const isTransparent = transparentHeader?.getAttribute('data-transparent-header');
    const mobileNavButtons = document.querySelectorAll('.navigation__button');
    
    if (hamburgerIcon) {
      hamburgerIcon.addEventListener('click', () => {
        navigationDrawer.classList.add('active');
        navigationOverlay.classList.add('active');
        html.classList.add('lock');
      });
    }
    if (closeIcon) {
      closeIcon.addEventListener('click', () => {
        navigationDrawer.classList.remove('active');
        navigationOverlay.classList.remove('active');
        html.classList.remove('lock');
      });
    }
    if (navigationOverlay) {
      navigationOverlay.addEventListener('click', () => {
        navigationDrawer.classList.remove('active');
        navigationOverlay.classList.remove('active');
        html.classList.remove('lock');
      });
    }
    // hasSubMenuElement.forEach(details => {
    //   if (details) {
    //     const summary = details.querySelector('summary');
    //     const dropdown = details.querySelector('.dropdown-menu');
    //     summary.addEventListener('click', e => e.preventDefault());
    //     let isHovering = false;
    //     const openMenu = () => {
    //       details.setAttribute('open', '');
    //       if (isTransparent) {
    //         transparentHeader.classList.add('header__background--accent');
    //         headerLogoHover.classList.add('header__logo--hover');
    //       }
    //       isHovering = true;
    //     };
    //     const closeMenu = () => {
    //       isHovering = false;
    //       hoverTimeout = setTimeout(() => {
    //         if (!isHovering) {
    //           details.removeAttribute('open');
    //           if (isTransparent) {
    //             transparentHeader.classList.remove('header__background--accent');
    //             headerLogoHover.classList.remove('header__logo--hover');
    //           }
    //         }
    //       }, 150);
          
    //     };
    //     summary.addEventListener('mouseenter', openMenu);
    //     details.addEventListener('mouseleave', closeMenu);
    //     dropdown.addEventListener('mouseenter', () => {
    //       isHovering = true;
    //       clearTimeout(hoverTimeout);
    //     });
    //     dropdown.addEventListener('mouseleave', closeMenu);
    //   }
      
    // });
    // megaMenuElement.forEach(details => {
    //   if (details) {
    //     const summary = details.querySelector('summary');
    //     const dropdown = details.querySelector('.mega-menu');
    //     summary.addEventListener('click', e => e.preventDefault());
    //     let isHovering = false;
    //     const openMenu = () => {
    //       details.setAttribute('open', '');
    //       if (isTransparent && transparentHeader) {
    //         transparentHeader.classList.add('header__background--accent');
    //         headerLogoHover.classList.add('header__logo--hover');
    //       }
    //       isHovering = true;
    //     };
    //     const closeMenu = () => {
    //       isHovering = false;
    //       hoverTimeout = setTimeout(() => {
    //         if (!isHovering) {
    //           details.removeAttribute('open');
    //           if (isTransparent) {
    //             transparentHeader.classList.remove('header__background--accent');
    //             headerLogoHover.classList.remove('header__logo--hover');
    //           }
    //         }
    //       }, 150);
    //     };
    //     summary.addEventListener('mouseenter', openMenu);
    //     details.addEventListener('mouseleave', closeMenu);
    //     dropdown.addEventListener('mouseenter', () => {
    //       isHovering = true;
    //       clearTimeout(hoverTimeout);
    //     });
    //     dropdown.addEventListener('mouseleave', closeMenu);
    //   }
      
    // });
    hasSubMenuElement.forEach(menu => {
      if (menu) {
        menu.addEventListener('mouseenter', () => {
          if (isTransparent && transparentHeader) {
            transparentHeader.classList.add('header__background--accent');
            headerLogoHover.classList.add('header__logo--hover');
          }
        });

        menu.addEventListener('mouseleave', () => {
          if (isTransparent && transparentHeader) {
            transparentHeader.classList.remove('header__background--accent');
            headerLogoHover.classList.remove('header__logo--hover');
          }
        });
      }
    });
    megaMenuElement.forEach(menu => {
      if (menu) {
        menu.addEventListener('mouseenter', () => {
          if (isTransparent && transparentHeader) {
            transparentHeader.classList.add('header__background--accent');
            headerLogoHover.classList.add('header__logo--hover');
          }
        });

        menu.addEventListener('mouseleave', () => {
          if (isTransparent && transparentHeader) {
            transparentHeader.classList.remove('header__background--accent');
            headerLogoHover.classList.remove('header__logo--hover');
          }
        });
      }
    });

    mobileNavButtons.forEach(button => {
      if (button) {
        button.addEventListener('click', () => {
          button.classList.toggle('active');
          const submenu = button.closest('li').querySelector('.submenu');
          if (submenu) {
            submenu.classList.toggle('hidden');
          }
        });
      }
    });

  }
  function initMediaGallery() {
    let productmediaWrapper = document.querySelectorAll('.product-gallery__mobile');
    productmediaWrapper.forEach(wrapper => {
      let id = wrapper.dataset.sectionId;
      let MediaSliderContainer = wrapper.querySelector('#gallery-' + id);
      
      if (MediaSliderContainer) {
        if (MediaSliderContainer.swiper) {
          MediaSliderContainer.swiper.destroy();
        }
        let mediaSwiperOptions = {
          slidesPerView: 1,
          spaceBetween: 12,
          autoHeight: true,
          speed: 1000,
          pagination: {
            el: ".swiper-pagination",
          },
        }
        mediaSwiper[id] = new Swiper(MediaSliderContainer, mediaSwiperOptions);
      }
    })
  }
  function initCartForm() {
    const quantitySelectorInput = document.querySelectorAll('[data-item-input]');
    const removeButton = document.querySelectorAll('[data-item-remove]');
    const cartContainer = document.querySelectorAll('[data-cart]');
    const cartForm = document.querySelectorAll('#cart_form');
    const subTotal = document.querySelectorAll('[data-subtotal]');
    const freeShippingBar = document.querySelectorAll('.free-shipping');
    const cartItemCounter = document.querySelectorAll('[data-cart-count]');
  
    // quantity Change Event
    quantitySelectorInput.forEach(input => {
      if (input) {
        input.addEventListener('change', (event) => {
          let value = Number(input.value);
          let key = input.closest('[data-key]').dataset.key;
          
          const cartLineItem = input.closest('[data-key]');
          updateCart(key, value);
        });
      }
    });
  
    // remove Button Event
    removeButton.forEach(button => {
      if (button) {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const itemToRemove = button.closest('[data-key]');
          const key = itemToRemove.dataset.key;
          removeItem(key,0,itemToRemove);
        });
      }
    });
    function updateCart(key,quantity) {
      var requestData = {
        id: key,
        quantity: quantity
      };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestData)
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(cartData) {
        updateSubtotal(cartData);
        updateCartCount(cartData);
        updateSippingBar(cartData);
      })
      .catch(function(error) {
        console.error('Error updating cart:', error);
      });
    }
  
    function removeItem(key, quantity, itemToRemove) {
      var requestData = {
        id: key,
        quantity: 0,
        itemToRemove: itemToRemove
      };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestData)
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(cartData) {
        removeLineItem(cartData.items, itemToRemove);
        updateSubtotal(cartData);
        updateCartCount(cartData);
        updateSippingBar(cartData);
      })
      .catch(function(error) {
        console.error('Error updating cart:', error);
      });
    }
  
    function updateSubtotal(cartData) {
      subTotal.forEach(selector => {
        if (selector) {
          selector.textContent = formatMoney(cartData.total_price);
        }
      })
    }
  
    function updateCartCount(cartData) {
      cartItemCounter.forEach(counter => {
        if (counter) {
          if (cartData.item_count > 0) {
            counter.textContent = cartData.item_count;
            counter.classList.remove('hidden');
          } else {
            counter.remove();
          }
        }
      });
    }
  
    // function removeLineItem(items,itemToRemove) {
    //   cartContainer.forEach(container => {
    //     if (container) {
    //       const freeShippingBar = container.querySelector('.free-shipping');
    //       const emptyCart = document.createElement('div');
    //       emptyCart.className = 'cart__empty-message';
    //       emptyCart.innerHTML = `
    //         <div class="empty-state align-self-center">
    //           <div class="empty-state__icon-wrapper">
    //             <svg role="presentation" stroke-width="1" focusable="false" width="32" height="32" class="icon icon-cart" viewBox="0 0 22 22">
    //                 <path d="M14.666 7.333a3.666 3.666 0 1 1-7.333 0M3.33 6.785l-.642 7.7c-.137 1.654-.206 2.48.073 3.119a2.75 2.75 0 0 0 1.21 1.314c.612.332 1.442.332 3.102.332h7.853c1.66 0 2.49 0 3.103-.332a2.75 2.75 0 0 0 1.21-1.314c.279-.638.21-1.465.072-3.12l-.642-7.7c-.118-1.423-.178-2.134-.493-2.673A2.75 2.75 0 0 0 16.99 3.02c-.563-.269-1.277-.269-2.705-.269h-6.57c-1.428 0-2.142 0-2.705.27A2.75 2.75 0 0 0 3.823 4.11c-.315.539-.374 1.25-.493 2.674Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
    //               </svg>
    //             <span class="count-bubble count-bubble--lg">0</span>
    //           </div>
    //           <div class="prose">
    //             <p class="h5">${window.variantStrings.cartEmptyMessage}</p>
    //             <a class="button button--xl" href="${window.routes.all_collections}">${window.variantStrings.continue_shopping}</a>
    //           </div>
    //         </div>
    //       `;
    //       if (items.length === 0) {
    //         if (freeShippingBar && freeShippingBar.innerHTML != "") {
    //           freeShippingBar.remove();
    //         }
    //         container.closest('.cart-drawer__content').classList.add('empty-cart__drawer');
    //         container.appendChild(emptyCart);
    //       } else {
    //         if (itemToRemove) {
    //           itemToRemove.remove();
    //         } else {
    //           console.warn('Item to remove not found in DOM.');
    //         }
    //       }
    //     }
    //   });
    // }
    function removeLineItem(items, itemToRemove) {
      cartContainer.forEach(container => {
        if (container) {
          const freeShippingBar = container.querySelector('.free-shipping');
          const emptyCart = document.createElement('div');
          emptyCart.className = 'cart__empty-message';
          emptyCart.innerHTML = `
            <div class="empty-state align-self-center">
              <div class="empty-state__icon-wrapper">
                <svg role="presentation" stroke-width="1" focusable="false" width="32" height="32" class="icon icon-cart" viewBox="0 0 22 22">
                  <path d="M14.666 7.333a3.666 3.666 0 1 1-7.333 0M3.33 6.785l-.642 7.7c-.137 1.654-.206 2.48.073 3.119a2.75 2.75 0 0 0 1.21 1.314c.612.332 1.442.332 3.102.332h7.853c1.66 0 2.49 0 3.103-.332a2.75 2.75 0 0 0 1.21-1.314c.279-.638.21-1.465.072-3.12l-.642-7.7c-.118-1.423-.178-2.134-.493-2.673A2.75 2.75 0 0 0 16.99 3.02c-.563-.269-1.277-.269-2.705-.269h-6.57c-1.428 0-2.142 0-2.705.27A2.75 2.75 0 0 0 3.823 4.11c-.315.539-.374 1.25-.493 2.674Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span class="count-bubble count-bubble--lg">0</span>
              </div>
              <div class="prose">
                <p class="h5">${window.variantStrings.cartEmptyMessage}</p>
                <a class="button button--xl" href="${window.routes.all_collections}">${window.variantStrings.continue_shopping}</a>
              </div>
            </div>
          `;
    
          const emptyCartMessage = container.querySelector('.cart__empty-message');
          const drawerContent = container.closest('.cart-drawer');
    
          if (items.length === 0) {
            // Remove shipping bar if exists
            if (freeShippingBar && freeShippingBar.innerHTML !== "") {
              freeShippingBar.remove();
            }
    
            // Add empty cart state if not already present
            if (!emptyCartMessage) {
              drawerContent.classList.add('empty-cart__drawer');
              container.appendChild(emptyCart);
            }
          } else {
            // Cart has items — remove empty cart state
            if (emptyCartMessage) {
              emptyCartMessage.remove();
            }
            if (drawerContent.classList.contains('empty-cart__drawer')) {
              drawerContent.classList.remove('empty-cart__drawer');
            }
    
            // Remove the specific item
            if (itemToRemove) {
              itemToRemove.remove();
            } else {
              console.warn('Item to remove not found in DOM.');
            }
          }
        }
      });
    }
  
    function updateSippingBar(cartData) {
      freeShippingBar.forEach(bar => {
        const thresholdTotal = bar.dataset.freeShippingThreshold;
        const cartTotal = cartData.total_price;
        const progress = cartTotal / thresholdTotal;
        const progressBar = bar.querySelector('.progress-bar');
        const freeShippingText = bar.querySelector('[data-free-shipping-bar]');
        progressBar.style.setProperty('--progress', progress);
        if (cartTotal < thresholdTotal) {
          const remainingAmount = formatMoney(thresholdTotal - cartTotal);
          freeShippingText.innerHTML = `Spend ${remainingAmount} more to qualify for free shipping.`;
        } else {
          const totalPrice = formatMoney(thresholdTotal);
          freeShippingText.textContent = `Congratulations you qualify for free shipping over ${totalPrice}`;
        }
      })
    }
  }
  function initStickyAddCart() {
    const stickyCart = document.querySelector("[data-sticky-cart]");
    if (stickyCart) {
      const addToCartButton = document.querySelector("[data-add-to-cart]");
      window.addEventListener("scroll", function() {
        const buttonRect = addToCartButton.getBoundingClientRect();
        if (buttonRect.bottom < 0) {
            stickyCart.classList.add('is-visible');
        } else {
            stickyCart.classList.remove('is-visible');
        }
      });
    }
  }
  function initProductVariants() {
    let selectors = {
      masterVariantSelector: document.querySelectorAll('.selected-variant__id'),
      productGrid: document.querySelectorAll('[data-main-product]')
    };
  
    selectors.productGrid.forEach(product => {
      if(!product) return;
      const variantSelectors = product.querySelectorAll('[data-selected-variant]');
      variantSelectors.forEach(selector => {
        selector.addEventListener('change', () => {
          updateProductOptions(variantSelectors, product);
        });
      });
    });
  
    function updateProductOptions(variantSelectors, product) {
      let selectedOptions = [];
      variantSelectors.forEach(selector => {
        if (selector) {
          if (selector.type === 'radio' || selector.type === 'checkbox') {
            if (selector.checked) {
              selectedOptions.push(selector.value);
            }
          } else {
            selectedOptions.push(selector.value);
          }
        }
      });
      
      // Find the matched variant
      getVariant(selectedOptions,product);
    }

    function getVariant(selectedOptions, product) {
      const historyEnabled = product.dataset.historyUrl;
      const productId = product.dataset.productId;

      const productJsonEl = document.getElementById(`ProductJson-${productId}`);
      if (!productJsonEl) return;

      const productData = JSON.parse(productJsonEl.textContent);
      let matchedVariant = productData.variants.find(variant => {
        return selectedOptions.every(option => variant.options.includes(option));
      });

      if (matchedVariant) {
        updateMasterVariant(matchedVariant, product);
        // updateOptionsNames(matchedVariant, product);
        if (historyEnabled == 'true') {
          updateUrl(matchedVariant);
        }
        updateProductPrice(matchedVariant, product);
        updateProductUnitPrice(matchedVariant, product);
        updateButtons(matchedVariant, product);
        updateMedia(matchedVariant, product);
        updateInventoryStatus(matchedVariant, product);
      }
    }

    function updateMasterVariant(matchedVariant, product) {
      const masterVariantSelector = product.querySelector('.selected-variant__id');
      if(!masterVariantSelector) return;
      masterVariantSelector.value = matchedVariant.id;
    }

    function updateUrl(matchedVariant) {
      if (!history.replaceState || !matchedVariant) {
        return;
      }
  
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + matchedVariant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    }

    function updateProductPrice(matchedVariant, product) {
      const productSalePrice = product.querySelector('[data-price]');
      const productRegularPrice = product.querySelector('[data-compare-price]');
      if(!productSalePrice) return;
      productSalePrice.textContent = formatMoney(matchedVariant.price);
      
      if(!productRegularPrice) return;
      productRegularPrice.textContent = formatMoney(matchedVariant.compare_at_price);
        matchedVariant.compare_at_price > matchedVariant.price ?
          productRegularPrice.classList.remove('hidden') :
          productRegularPrice.classList.add('hidden');
    }
    function updateProductUnitPrice(matchedvariant, product) {
      const productUnitPrice = product.querySelector('[data-unit-price]');
      if(!productUnitPrice) return;
      if (matchedvariant.unit_price) {
        productUnitPrice.classList.remove('hidden');
        productUnitPrice.textContent = `${matchedvariant.unit_price}/${matchedvariant.unit_price_measurement.reference_value} ${matchedvariant.unit_price_measurement.reference_unit}`;
      } else {
        productUnitPrice.classList.add('hidden');
      }
    }
  
    function updateButtons(matchedVariant, product) {
      const productAddToCartBtn = product.querySelector('[data-add-to-cart]');
      const productAddToCartBtnSpan = product.querySelector('[data-add-to-cart] .product-form-btn__text');
      if(!productAddToCartBtn) return;
      if (matchedVariant.available) {
        productAddToCartBtnSpan.textContent = window.variantStrings.addToCart;
        productAddToCartBtn.disabled = false;
      } else {
        productAddToCartBtnSpan.textContent = window.variantStrings.soldOut;
        productAddToCartBtn.disabled = true;
      }
    }

    function updateMedia(matchedVariant, product) {
      if (matchedVariant.featured_media) {
        var selectedVariantId = matchedVariant.featured_media.id;
        const slide = product.querySelector(`.product__thumbs [data-media-id="${selectedVariantId}"]`);
        const sectionId = product.dataset.sectionId;
        const mediaSwiperSlider = mediaSwiper[sectionId];

        // if (slide) {
        //   const index = slide.dataset.index;
        //   mediaSwiperSlider.slideTo(index - 1);
        // }
        if (mediaSwiperSlider) {
          const allSlides = product.querySelectorAll('.swiper-slide');
          const targetIndex = Array.from(allSlides).findIndex(
            (s) => s.dataset.mediaId === selectedVariantId.toString()
          );

          if (targetIndex >= 0) {
            mediaSwiperSlider.slideTo(targetIndex);
          }
        }
    
        const productGrid = product.querySelector('.product-gallery__media-list');
        
        // if (productGrid) {
        //   const gridItems = productGrid.querySelectorAll('.product-gallery__media');
        //   // const seletedMediaItem = productGrid.querySelector('.product-gallery__media.selected__media img');
        //   // seletedMediaItem.src = selectedVariantImage.src;
        //   const activeGridItem = productGrid.querySelector(`[data-media-id="${selectedVariantId}"]`);
        //   gridItems.forEach(item => {
        //     if (!item) return;
        //     item.classList.remove('active');
        //   });
          
        //   if (!activeGridItem) return;
        //   activeGridItem.closest('.product-gallery__media').classList.add('active');
        //   const index = activeGridItem.dataset.index;
        //   productGrid.insertBefore(activeGridItem.closest('.product-gallery__media'), productGrid.firstChild);
         
        // }
        if (productGrid) {
          const selectedMediaItem = productGrid.querySelector('.product-gallery__media.selected__media img');
          if (selectedMediaItem) {
            selectedMediaItem.setAttribute('src', matchedVariant.featured_image.src);
            selectedMediaItem.setAttribute('alt', matchedVariant.featured_image.src.alt);
          }
        }

        const stickyCartImage = document.querySelector('.product__sticky-image');
        if (stickyCartImage) {
          stickyCartImage.setAttribute('src', matchedVariant.featured_image.src);
        }
      }
    }
  
    function updateOptionsNames(matchedVariant, product) {
      let option1 = product.querySelector('[data-selected-option="selectedOption1"]');
      let option2 = product.querySelector('[data-selected-option="selectedOption2"]');
      let option3 = product.querySelector('[data-selected-option="selectedOption3"]');
      if(!option1) return;
      option1.querySelector('[data-option-name]').textContent = matchedVariant.option1;
      if(!option2) return;
      option2.querySelector('[data-option-name]').textContent = matchedVariant.option2;
      if(!option3) return;
      option3.querySelector('[data-option-name]').textContent = matchedVariant.option3;
    }

    function updateInventoryStatus(matchedVariant, product) {
      const requestedVariantId = matchedVariant.id;
      fetch(
        `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${matchedVariant.id}`)
        .then((response) => response.text())
        .then((responseText) => {
          if (matchedVariant.id !== requestedVariantId) return;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const inventorySource = html.querySelector('[data-inventory]');
          const inventoryDestination = product.querySelector('[data-inventory]');
          if (!inventorySource || !inventoryDestination) {
            return;
          }
          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        });
    }
  }


  function initFrequentProductVariants() {
    const productGrid = document.querySelectorAll('[data-frequent-product]');
  
    productGrid.forEach(product => {
      if(!product) return;
      const variantSelectors = product.querySelectorAll('[data-variant-selected]');
      variantSelectors.forEach(selector => {
        selector.addEventListener('change', () => {
          updateProductOptions(variantSelectors, product);
        });
      });
    });
  
    function updateProductOptions(variantSelectors, sourceProductElement) {
      let selectedOptions = [];
    
      variantSelectors.forEach(selector => {
        if (selector) {
          if (selector.type === 'radio' || selector.type === 'checkbox') {
            if (selector.checked) {
              selectedOptions.push(selector.value);
            }
          } else {
            selectedOptions.push(selector.value);
          }
        }
      });
    
      const handle = sourceProductElement.dataset.productHandle;
      const allProductBlocks = document.querySelectorAll(`[data-product-handle="${handle}"]`);
      
      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(productData => {
          let matchedVariant = productData.variants.find(variant =>
            selectedOptions.every(option => variant.options.includes(option))
          );
    
          if (matchedVariant) {
            allProductBlocks.forEach(productEl => {
              updateMasterVariant(matchedVariant, productEl);
              updateProductPrice(matchedVariant, productEl);
              updateVariantSelectInputs(matchedVariant, productEl);
            });
          }
        })
        .catch(err => {
          console.error("Error fetching product data:", err);
        });
    }
    
    function updateMasterVariant(matchedVariant, product) {
      const masterVariantSelector = product.querySelector('.frequent-product-id');
      if(!masterVariantSelector) return;
      masterVariantSelector.value = matchedVariant.id;
    }
  
    function updateProductPrice(matchedVariant, product) {
      const productSalePrice = product.querySelectorAll('[data-price]');
      const productRegularPrice = product.querySelectorAll('[data-compare-price]');
      productSalePrice.forEach(price => {
        if (price) {
          price.textContent = formatMoney(matchedVariant.price);
        }
      });
      productRegularPrice.forEach(price => {
        if (price) {
          price.textContent = formatMoney(matchedVariant.compare_at_price);
          matchedVariant.compare_at_price > matchedVariant.price ?
            price.classList.remove('hidden') :
            price.classList.add('hidden');
        }
      });
    }

    function updateVariantSelectInputs(matchedVariant, productEl) {
      const selectors = productEl.querySelectorAll('[data-variant-selected]');
      if (!selectors.length) return;
    
      matchedVariant.options.forEach((option, index) => {
        const selector = selectors[index];
        if (selector && selector.value !== option) {
          selector.value = option;
        }
      });
    }
  }
  function cartCountdownEvents() {
    const wrappers = document.querySelectorAll('.cart-countdown');

    wrappers.forEach((wrapper, index) => {
      const container = wrapper.querySelector('.countdown-timer');
      if (!container) return;

      const storageKey = `cartTimerState_${index}`;

      let minutes = parseInt(wrapper.dataset.countdownTimer, 10) || 0;
      let seconds = 0;

      const stored = localStorage.getItem(storageKey);
      if (stored) {
        const parsed = JSON.parse(stored);
        minutes = parsed.minutes;
        seconds = parsed.seconds;
      }

      if (wrapper._timer) {
        clearInterval(wrapper._timer);
      }

      wrapper._timer = setInterval(() => {
        if (minutes === 0 && seconds === 0) {
          minutes = parseInt(wrapper.dataset.countdownTimer, 10) || 0;
          seconds = 0;
        } else {
          if (seconds === 0) {
            minutes--;
            seconds = 59;
          } else {
            seconds--;
          }
        }

        const mm = minutes.toString().padStart(2, '0');
        const ss = seconds.toString().padStart(2, '0');

        container.textContent = `${mm}m:${ss}s`;

        localStorage.setItem(
          storageKey,
          JSON.stringify({ minutes, seconds })
        );
      }, 1000);
    });
  }
  function initProductForm() {
    const cartHeaderIcon = document.querySelectorAll('[data-cart-icon]');
    const drawerCloseIcon = document.querySelectorAll('.cart-drawer .drawer__close-icon');
    const cartDrawer = document.querySelectorAll('.cart-drawer');
    const cartDrawerOverlay = document.querySelector('.cart-drawer__overlay');
    const productForm = document.querySelectorAll(`form[action="${window.routes.cart_add_url}"]`);
    const cartItemCounter = document.querySelectorAll('[data-cart-count]');
    const cartTotal = document.querySelectorAll('[data-subtotal]');
    const cartDrawerContent = document.querySelector("[data-cart]");

    const sizeChartIcon = document.querySelectorAll('[data-size-chart]');
    const sizeChartContainer = document.querySelector('.size-chart__drawer');
    const sizeChartContainerOverlay = document.querySelector('.size-chart__drawer .overlay');
    const sizeChartContainerClose = document.querySelectorAll('.close-size__icon');
    cartHeaderIcon.forEach(button => {
      if (button) {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          openCartDrawer();
        });
      }
    });
    drawerCloseIcon.forEach(button => {
      if (button) {
        button.addEventListener('click', (event) => {
          closeCartDrawer();
        });
      }
    });
    if (cartDrawerOverlay) {
      cartDrawerOverlay.addEventListener('click', (event) => {
        closeCartDrawer();
      });
    }
  
    // productForm.forEach(form => {
    //   if (!form) {
    //     return;
    //   }
    //   form.addEventListener('submit', async (event) => {
    //     const loader = form.querySelector('[data-add-to-cart] .button__loader');
    //     const span = form.querySelector('[data-add-to-cart] .product-form-btn__text');
    //     event.preventDefault();
    //     showLoader(loader,span);
        
    //     await submitProductForm(form);
    //     hideLoader(loader,span);
    //   });
    // });
  
    sizeChartIcon.forEach(button => {
      if (button) {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          openSizeChartDrawer();
        });
      }
    });
    sizeChartContainerClose.forEach(button => {
      if (button) {
        button.addEventListener('click', () => {
          closeSizeChartDrawer();
        });
      }
    });
    if (sizeChartContainerOverlay) {
      sizeChartContainerOverlay.addEventListener('click', () => {
        closeSizeChartDrawer();
      });
    }
    async function submitProductForm(form) {
      await fetch('/cart/add', {
        method: "POST",
        body: new FormData(form),
      });
  
      await updateCartDrawer();
  
      openCartDrawer();

      const res = await fetch("/cart.js");
      const cartData = await res.json();
      cartItemCount(cartData);
      updateCartDrawerState(cartData);
    }   
    async function updateCartDrawer() {
      const res = await fetch("/?section_id=custom-cart-drawer");
      const text = await res.text();
      const html = document.createElement("div");
      html.innerHTML = text;
      const newBox = html.querySelector("[data-cart]").innerHTML;
      if (cartDrawerContent) {
        cartDrawerContent.innerHTML = newBox;
        const newCloseBtn = cartDrawerContent.querySelector('.drawer__close-icon');
        if (newCloseBtn) {
          newCloseBtn.addEventListener('click', () => {
            closeCartDrawer();
          });
        }
        initCartForm();
        // initProductForm();
        showMoreProducts();
        cartCountdownEvents();
      }
    }
    function openCartDrawer() {
      cartDrawer.forEach(drawer => {
        if (drawer) {
          drawer.classList.add('active');
          cartDrawerOverlay.classList.add('active');
        }
      });
      html.classList.add('lock');
    }
    function closeCartDrawer() {
      cartDrawer.forEach(drawer => {
        if (drawer) {
          drawer.classList.remove('active');
          cartDrawerOverlay.classList.remove('active');
        }
      });
      html.classList.remove('lock');
    }
    function openSizeChartDrawer() {
      if (sizeChartContainer) {
        sizeChartContainer.classList.add('active');
        sizeChartContainerOverlay.classList.add('active');
      }
    }
    function closeSizeChartDrawer() {
      if (sizeChartContainer) {
        sizeChartContainer.classList.remove('active');
        sizeChartContainerOverlay.classList.remove('active');
      }
    }
    function updateCartDrawerState(cartData) {
      if (cartData.item_count === 0) {
        cartDrawer.forEach(drawer => {
          if (drawer) {
            drawer.classList.add('empty-cart__drawer');
          }
        });
      } else {
        cartDrawer.forEach(drawer => {
          if (drawer) {
            drawer.classList.remove('empty-cart__drawer');
          }
        });
      }
    }
    function cartItemCount(cartData) {
      cartItemCounter.forEach(counter => {
        if (!counter) {
          return;
        }
        if (cartData.item_count > 0) {
          counter.textContent = cartData.item_count;
          counter.classList.remove('hidden');
        } else {
          counter.remove();
        }
      });
      cartTotal.forEach(total => {
        if (total) {
          total.textContent = formatMoney(cartData.total_price);
        }
      });
    }
    function showLoader(loader,span) {
      if (loader && span) {
        loader.classList.remove('hidden');
        span.classList.add('hidden');
      }
    }
    function hideLoader(loader,span) {
      if (loader && span) {
        loader.classList.add('hidden');
        span.classList.remove('hidden');
      }
    }
  }
  function initQuickAdd() {
    const quickShopBtn = document.querySelectorAll('[data-quick-buy]');
    const quickShopModal = document.querySelector('.quick-buy-drawer');
    const modalCloseBtn = document.querySelector('[data-quick-close]');
    const quickShopOverlay = document.querySelector('.quick-buy__box');
    const quickShopContent = document.querySelector('.quick-buy__content');
    const quickViewContainer = document.querySelector('.quick-buy__container');
    
    quickShopBtn.forEach(button => {
      if (button) {
        button.addEventListener('click', () => {
          openQuickShopModal();
        });
      }
    });
    
    if (modalCloseBtn) {
      modalCloseBtn.addEventListener('click', () => {
        closeQuickShopModal();
      });
    }
  
    if (quickShopModal) {
      quickShopModal.addEventListener('click', () => {
        closeQuickShopModal();
      });
    }
    if (quickShopOverlay) {
      quickShopOverlay.addEventListener('click', () => {
        closeQuickShopModal();
      });
    }
    if (quickShopContent) {
      quickShopContent.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
  
    function openQuickShopModal() {
      quickShopModal.classList.add('active');
      quickShopOverlay.classList.add('active');
      html.classList.add('lock');
    }
    function closeQuickShopModal() {
      quickShopModal.classList.remove('active');
      quickShopOverlay.classList.remove('active');
      html.classList.remove('lock');
    }
    const products = document.querySelectorAll('[data-quick-buy]');
  
    if (!products.length) {
      return;
    }
  
    products.forEach(product => {
      product.addEventListener('click', productClick);
    });
  
    function productClick(evt) {
      let el = evt.currentTarget;
      let productId = el.dataset.productId;
      let handle = el.dataset.productHandle;
      let btn = el.querySelector('[data-quick-buy]');
      preloadProductModal(handle, productId, btn);
    }
    function preloadProductModal(handle, productId) {
      let url = `${window.routes.home}/products/${handle}?view=quick-view`;
      url = url.replace('//', '/');
      fetch(url)
      .then(function(responce) {
        return responce.text();
      })
      .then(function(data) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(data, 'text/html');
        const html = document.createElement('div');
        html.innerHTML = data;
        let newData = doc.querySelector('[data-product-info][data-product-handle="'+handle+'"]');
  
        if (newData) {
          let productDescription = newData.querySelector('.product-info__container');
          let productTitle = productDescription.querySelector('.quick-buy__header');
          let productVariants = productDescription.querySelector('.product-info__variant-picker');
          let productButtons = productDescription.querySelector('.product-info__buy-buttons');
          if (productDescription) {
            productDescription.innerHTML = '';
            if (productTitle) {
              productDescription.appendChild(productTitle);
            }
            if (productVariants) {
              productDescription.appendChild(productVariants);
            }
            if (productButtons) {
              productDescription.appendChild(productButtons);
            }
          }
          newData.appendChild(productDescription);
        }
  
        if (quickViewContainer) {
          quickViewContainer.innerHTML = '';
          quickViewContainer.appendChild(newData);
          const newCloseBtn = quickViewContainer.querySelector('[data-quick-close]');
          if (newCloseBtn) {
            newCloseBtn.addEventListener('click', () => {
              closeQuickShopModal();
            });
          }
          initProductVariants();
          initProductForm();
        }
      })
      .catch(function(error) {
        console.log('Error', error);
      });
    }
  }
  function collectionSorting() {
    const sortBtn = document.querySelectorAll('.collection-sort__btn');
    const sortButtons = document.querySelectorAll('[name="sort_by"]');
    const sortListboxOptions = document.querySelectorAll('.popover-listbox__option');
    const sectionContainer = document.querySelector('[data-id="CollectionProductGrid"]');
    const isMobile = window.innerWidth <= 915;
    sortBtn.forEach(button => {
      const popover = button.closest('.sort-by-facet').querySelector('.popover');
      
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        closeAllPopovers();
        if (!isOpen) {
          button.setAttribute('aria-expanded', 'true');
          popover.classList.add('is-active');
        } else {
          button.setAttribute('aria-expanded', 'false');
          popover.classList.remove('is-active');
        }
      });
    });
    document.addEventListener('click', () => {
      closeAllPopovers();
    });
    function closeAllPopovers() {
      document.querySelectorAll('.collection-sort__btn').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('.sort-by-facet .popover').forEach(popover => {
        popover.classList.remove('is-active');
      });
    }
  
    sortButtons.forEach(button => {
      button.addEventListener('change', (e) => {
        const value = e.target.value;
        updateCollectionWithSort(value);
      });
    });
  
    sortListboxOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        const value = e.currentTarget.getAttribute('value');
        const optionName = e.currentTarget.querySelector('.reversed-link').textContent;
        const currentItemLabel = document.querySelector('.collection-sort__btn .reversed-link');
        if (currentItemLabel) {
          currentItemLabel.textContent = optionName;
        }
        if (value) {
          updateCollectionWithSort(value);
        }
      });
    });
  
    function updateCollectionWithSort(sortValue) {
      const currentURL = new URL(window.location.href);
      currentURL.searchParams.set('sort_by', sortValue);
      fetch(currentURL.href)
        .then(res => res.text())
        .then(html => {
          const tempDOM = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = tempDOM.querySelector('[data-id="CollectionProductGrid"]');
          if (newGrid && sectionContainer) {
            sectionContainer.innerHTML = newGrid.innerHTML;
            window.history.pushState({}, '', currentURL.href);
          }
        })
        .catch(err => console.error('AJAX sort error:', err));
    }
  }
  function collectionFilters() {
    const floatingFilterButton = document.querySelectorAll('.facets__floating-filter button');
    const collectionFilterButton = document.querySelectorAll('.collection-filter__btn');
    const floatingFilterDrawer = document.querySelector('.facets-drawer');
    const floatingFilterOverlay = document.querySelector('.main-collection__wrapper .overlay');
    const facetCloseButton = document.querySelector('.main-collection__wrapper .facet-drawer__close');
    const outsideCloseButton = document.querySelector('.main-collection__wrapper .outside-close-button');
    const loader = document.querySelector('.loader');
    const filterForm = document.querySelector('.facets-vertical');
    const filterOptions = document.querySelectorAll('.checkbox-list input[type="checkbox"]');
    const filterPriceOptions = document.querySelectorAll('.input-group input[type="number"]');
    const filterRangeSliders = document.querySelectorAll('.range-group input[type="range"]');
    const applyButton = document.querySelector('[is="facet-apply-button"]');
    const isMobile = window.innerWidth <= 915;
    function filterSubmitForm() {
      const queryString = new URLSearchParams(window.location.search);
      const searchTerm = queryString.get("q");
      filterOptions.forEach(option => {
        queryString.delete(option.name);
      });
      filterPriceOptions.forEach(option => {
        queryString.delete(option.name);
      });
      filterOptions.forEach(option => {
        if (option.checked) {
          queryString.append(option.name, option.value);
        }
      });
      filterPriceOptions.forEach(option => {
        const priceValue = option.value.trim();
        if (priceValue !== '') {
          queryString.append(option.name, priceValue);
        }
      });
      if (searchTerm) {
        queryString.set("q", searchTerm);
      }
      const baseUrl = window.location.pathname + `?${queryString.toString()}`;
      if(!loader) return;
      loader.classList.remove('hidden');
      fetch(baseUrl)
        .then(responce => responce.text())
        .then(data => {
          let html = document.createElement('div');
          html.innerHTML = data;
          let productData = html.querySelector('.catalog__content').innerHTML;
          document.querySelector('.catalog__content').innerHTML = productData;
          // Check if there are no products
          const noProductsMessage = html.querySelector('.empty-products__message');
          if (noProductsMessage) {
            document.querySelector('.empty-products__message').classList.remove('hidden');
          } else {
            if (history.pushState) {
              history.pushState(null, null, `?${queryString.toString()}`);
            } else {
              window.location.href = `?${queryString.toString()}`;
            }
          }
          initQuickAdd();
          collectionSorting();
          collectionFilters();
          initProductForm();
        })
        .catch(error => console.log('Error', error))
        .finally(() => loader.classList.add('hidden'));
    }
    filterOptions.forEach(option => {
      if (option) {
        option.addEventListener('change', updateFilterCount);
      }
    });
    filterPriceOptions.forEach(option => {
      if (option) {
        option.addEventListener('input', updateFilterCount);
      }
    });
    filterRangeSliders.forEach(slider => {
      if (slider) {
        slider.addEventListener('input', updateFilterCount);
      }
    });
    floatingFilterButton.forEach(button => {
      if (button) {
        button.addEventListener('click', () => {
          floatingFilterDrawer.classList.add('active');
          if (floatingFilterOverlay) {
            floatingFilterOverlay.classList.add('active');
            html.classList.add('lock');
            outsideCloseButton.classList.add('active');
          }
        });
      }
    });
    collectionFilterButton.forEach(button => {
      if (button) {
        button.addEventListener('click', () => {
          floatingFilterDrawer.classList.add('active');
          if (floatingFilterOverlay) {
            floatingFilterOverlay.classList.add('active');
            html.classList.add('lock');
            outsideCloseButton.classList.add('active');
          }
        });
      }
    });
    if (floatingFilterOverlay) {
      floatingFilterOverlay.addEventListener('click', () => {
        floatingFilterDrawer.classList.remove('active');
        floatingFilterOverlay.classList.remove('active');
        html.classList.remove('lock');
        outsideCloseButton.classList.remove('active');
      });
    }
    if (facetCloseButton) {
      facetCloseButton.addEventListener('click', () => {
        floatingFilterDrawer.classList.remove('active');
        floatingFilterOverlay.classList.remove('active');
        html.classList.remove('lock');
        outsideCloseButton.classList.remove('active');
      });
    }
    if (outsideCloseButton) {
      outsideCloseButton.addEventListener('click', () => {
        floatingFilterDrawer.classList.remove('active');
        floatingFilterOverlay.classList.remove('active');
        html.classList.remove('lock');
        outsideCloseButton.classList.remove('active');
      });
    }
    if (applyButton) {
      applyButton.addEventListener('click', () => {
        filterSubmitForm();
      });
    }
    function updateFilterCount() {
      let count = 0;
      filterOptions.forEach(option => {
        if (option.checked) count++;
      });
      filterPriceOptions.forEach(option => {
        if (option.value.trim() !== '') count++;
      });
    
      const countSpan = document.querySelector('[data-filter-count]');
      if (countSpan) {
        countSpan.textContent = count > 0 ? ` (${count})` : '';
      }
    }
    // function syncPriceRangeInputs() {
    //   const [minSlider, maxSlider] = filterRangeSliders;
    //   const [minInput, maxInput] = filterPriceOptions;
    
    //   if (minSlider) {
    //     minSlider.addEventListener('input', () => {
    //       minInput.value = minSlider.value;
    //       updateFilterCount();
    //     });
    //   }
    //   if (maxSlider) {
    //     maxSlider.addEventListener('input', () => {
    //       maxInput.value = maxSlider.value;
    //       updateFilterCount();
    //     });
    //   }
    //   if (minInput) {
    //     minInput.addEventListener('input', () => {
    //       minSlider.value = minInput.value;
    //       updateFilterCount();
    //     });
    //   }
    //   if (maxInput) {
    //     maxInput.addEventListener('input', () => {
    //       maxSlider.value = maxInput.value;
    //       updateFilterCount();
    //     });
    //   }
    // }
    // syncPriceRangeInputs();
  }
  function accordions() {
    document.querySelectorAll('details').forEach((accordion) => {
      if (accordion) {
        accordion.addEventListener('toggle', function () {
          this.setAttribute('aria-expanded', this.open ? 'true' : 'false');
        });
      }
    });
  }
  function recommendationsSlider() {
    const sliderWrapper = document.querySelectorAll('[data-recommended-products]');
    sliderWrapper.forEach(wrapper => {
      if (wrapper) {
        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#slider-'+ id);
        const nextElement = wrapper.querySelector('.feature__next-button');
        const prevElement = wrapper.querySelector('.feature__prev-button');
        const scrollBar = wrapper.querySelector('.swiper-scrollbar');
        if (container) {
          if (container.swiper) {
            container.swiper.destroy();
          }
    
          let swiperOptions = {
            effect: "slide",
            grabCursor: true,
            slidesPerView: 1.2,
            spaceBetween: 24,
            speed: 1000,
            navigation: {
              nextEl: nextElement,
              prevEl: prevElement,
            },
            scrollbar: {
              el: scrollBar,
              hide: true,
            },
            breakpoints: {
              700: {
                slidesPerView: 2.2,
              },
              1000: {
                slidesPerView: 5.2,
              },
            },
          };
          let swiper = new Swiper(container, swiperOptions);
        }
      }
    });
  }
  function initProductRecommendations() {
    const productRecommendationContainer = document.querySelectorAll('product-recommendations');
    if (productRecommendationContainer) {
      productRecommendationContainer.forEach(container => {
        const intent = container.getAttribute('data-intent');
        const sectionId = container.getAttribute('data-section-id');
        const productId = container.getAttribute('data-product-id');
        const recommendationsCount = container.getAttribute('data-limit');
        const productGridWrapper = container.querySelector('.product-recommendation__wrapper');
        async function fetchData() {
          try {
            const response = await fetch(`${window.routes.productRecommendation}?section_id=${sectionId}&product_id=${productId}&limit=${recommendationsCount}&intent=${intent}`);
            if (response.ok) {
              const data = await response.text();
              return data;
            } else {
              console.error(`Failed to fetch data: ${response.status} - ${response.statusText}`);
              return null;
            }
          } catch (error) {
            console.error('Error fetching data:', error);
            return null;
          }
        }
        async function replaceContent() {
          const data = await fetchData();
          const html = document.createElement('div');
          html.innerHTML = data;
          const recommendedProduct = html.querySelector('.product-recommendation__wrapper').innerHTML;
          if (data !== null) {
            productGridWrapper.innerHTML = recommendedProduct;
            recommendationsSlider();
            initProductForm();
          }
        }
        replaceContent();

      });
    }
  }
  function recentProductsSlider() {
    const sliderWrapper = document.querySelectorAll('[data-recent-products]');
    sliderWrapper.forEach(wrapper => {
      if (wrapper) {
        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#slider-'+ id);
        const nextElement = wrapper.querySelector('.feature__next-button');
        const prevElement = wrapper.querySelector('.feature__prev-button');
        const scrollBar = wrapper.querySelector('.swiper-scrollbar');
        if (container) {
          if (container.swiper) {
            container.swiper.destroy();
          }
    
          let swiperOptions = {
            effect: "slide",
            grabCursor: true,
            slidesPerView: 1.2,
            spaceBetween: 24,
            speed: 1000,
            navigation: {
              nextEl: nextElement,
              prevEl: prevElement,
            },
            scrollbar: {
              el: scrollBar,
              hide: true,
            },
            breakpoints: {
              700: {
                slidesPerView: 2.2,
              },
              1000: {
                slidesPerView: 5.2,
              },
            },
          };
          let swiper = new Swiper(container, swiperOptions);
        }
      }
    });
  }
  function testimonialSlider() {
    const sliderWrapper = document.querySelectorAll('.testimonial__slider--container');
    sliderWrapper.forEach(wrapper => {
      if (wrapper) {
        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#slide-'+ id);
        const nextElement = wrapper.querySelector('.feature__next-button');
        const prevElement = wrapper.querySelector('.feature__prev-button');
        const scrollBar = wrapper.querySelector('.swiper-scrollbar');
        if (container) {
          if (container.swiper) {
            container.swiper.destroy();
          }
    
          let swiperOptions = {
            effect: "slide",
            grabCursor: true,
            slidesPerView: 1.2,
            spaceBetween: 24,
            speed: 1000,
            navigation: {
              nextEl: nextElement,
              prevEl: prevElement,
            },
            scrollbar: {
              el: scrollBar,
              hide: true,
            },
            breakpoints: {
              700: {
                slidesPerView: 1.6,
              },
              1000: {
                slidesPerView: 3,
              },
            },
          };
          let swiper = new Swiper(container, swiperOptions);
        }
      }
    });
  }
  function imageTextScrollingSlider() {
    const sliderWrapper = document.querySelectorAll('.images-scrolling-desktop');
    sliderWrapper.forEach(wrapper => {
      const id = wrapper.dataset.sectionId;
      console.log('Section ID:', id);
  
      const container = wrapper.querySelector('#slide-' + id);
      const contentBlocks = wrapper.querySelectorAll(".images-scrolling__content");
  
      if (!container) {
        console.warn('Swiper container not found for section:', id);
        return;
      }
  
      if (container.swiper) {
        container.swiper.destroy();
      }
  
      let swiper = new Swiper(container, {
        direction: "vertical",
        allowTouchMove: false,
        slidesPerView: 1,
        effect: "fade",
        fadeEffect: { crossFade: true },
      });
  
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.getAttribute("data-index"));
            console.log('Scrolling to slide:', index);
            swiper.slideTo(index);
          }
        });
      }, {
        threshold: 0.5,
      });
  
      contentBlocks.forEach((block) => observer.observe(block));
    });
  }
  function showMoreProducts() {
    const loadMoreBtn = document.getElementById('load-more-recommendations');
    const recommendationItems = document.querySelectorAll('.cart-recommendations__list--item');
    const cartRecommendationContainer = document.querySelector('.cart-drawer__recommendations');
  
    if (!recommendationItems.length || !cartRecommendationContainer) return;
  
    // First, remove already-in-cart products
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(cart => {
        const cartHandles = cart.items.map(item => item.handle);
  
        recommendationItems.forEach(item => {
          const handle = item.getAttribute('data-product-handle');
          if (cartHandles.includes(handle)) {
            item.remove();
          }
        });
  
        const updatedItems = document.querySelectorAll('.cart-recommendations__list--item');
  
        // Show first 4, hide the rest
        updatedItems.forEach((item, index) => {
          if (index < 4) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
  
        // Show or hide load more button
        if (updatedItems.length > 4) {
          loadMoreBtn?.classList.remove('hidden');
          cartRecommendationContainer.classList.remove('hidden');
        } else {
          loadMoreBtn?.classList.add('hidden');
          if (updatedItems.length === 0) {
            cartRecommendationContainer.classList.add('hidden');
          }
        }
      });
  
    // Handle "Load More" button click
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => {
        const hiddenItems = document.querySelectorAll('.cart-recommendations__list--item.hidden');
        hiddenItems.forEach(item => item.classList.remove('hidden'));
        loadMoreBtn.classList.add('hidden');
      });
    }
  }
  function initHeaderSearch() {
    const searchIcon = document.querySelectorAll('.predictive__search-btn');
    const searchContainer = document.querySelector('.search-drawer');
    const searchOverlay = document.querySelector('.search-drawer .overlay');
    const closeIcon = document.querySelectorAll('.close-search__icon');

    
    searchIcon.forEach(button => {
      if (button) {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          if (searchContainer) {
            searchContainer.classList.add('active');
            searchOverlay.classList.add('active');
            document.querySelector('#predictive__input').focus();
          }
        });
      }
    });
    closeIcon.forEach(button => {
      if (button) {
        button.addEventListener('click', () => {
          if (searchContainer) {
            searchContainer.classList.remove('active');
            searchOverlay.classList.remove('active');
          }
        });
      }
    });
    if (searchOverlay) {
      searchOverlay.addEventListener('click', () => {
        if (searchContainer) {
          searchContainer.classList.remove('active');
          searchOverlay.classList.remove('active');
        }
      });
    }
  }
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('#predictive__input');
      this.predictiveSearchResults = this.querySelector('#PredictiveResults');
      this.predictiveSearchMenu = this.querySelector('.predictive__menu');
      if (!this.input) {
        return;
      }
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }
    onChange() {
      const searchTerm = this.input.value.trim();
      if (!searchTerm.length) {
        this.close();
        return;
      }
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      fetch(`/search/suggest?q=${searchTerm}&section_id=custom-predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-custom-predictive-search').innerHTML;
          if (!this.predictiveSearchResults) {
            return;
          }
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
          predictiveSearchTabs();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.classList.remove('hidden');
      this.predictiveSearchMenu.classList.add('hidden');
    }
  
    close() {
      this.predictiveSearchResults.classList.add('hidden');
      this.predictiveSearchMenu.classList.remove('hidden');
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  customElements.define('custom-predictive-search', PredictiveSearch);
  function predictiveSearchTabs() {
    const tabButtons = document.querySelectorAll('.predictive-search__tab-item button');
    const tabPanels = document.querySelectorAll('.predictive-search__tab-content');
  
    if (!tabButtons.length || !tabPanels.length) return;
  
    function resetTabs() {
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabPanels.forEach(panel => panel.classList.remove('active'));
    }
  
    const preferredTabs = ['products', 'collections', 'pages', 'articles'];
    let firstAvailableTab = null;
  
    for (let tabName of preferredTabs) {
      const tabButton = document.querySelector(`.predictive-search__tab-item button[data-tab="${tabName}"]`);
      const tabPanel = document.querySelector(`#tab-panel-${tabName}`);
      if (tabButton && tabPanel) {
        firstAvailableTab = tabName;
        break;
      }
    }
  
    if (firstAvailableTab) {
      const firstTabButton = document.querySelector(`.predictive-search__tab-item button[data-tab="${firstAvailableTab}"]`);
      const firstPanel = document.querySelector(`#tab-panel-${firstAvailableTab}`);
      resetTabs();
      firstTabButton.classList.add('active');
      firstPanel.classList.add('active');
    }
  
    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const tabId = button.dataset.tab;
        const panel = document.querySelector(`#tab-panel-${tabId}`);
        if (!panel) return;
        resetTabs();
        button.classList.add('active');
        panel.classList.add('active');
      });
    });
  }
  function logoListSlider() {
    const sliderWrapper = document.querySelectorAll('.logo-bar__wrapper');
    sliderWrapper.forEach(wrapper => {
      if (wrapper) {
        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#slide-'+ id);
        if (container) {
          if (container.swiper) {
            container.swiper.destroy();
          }
    
          let swiperOptions = {
            effect: "slide",
            grabCursor: true,
            slidesPerView: 1,
            loop: true,
            spaceBetween: 24,
            speed: 1000,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
            breakpoints: {
              700: {
                slidesPerView: 2,
              },
              1000: {
                slidesPerView: 4,
              },
              1150: {
                slidesPerView: 5,
              },
            },
          };
          let swiper = new Swiper(container, swiperOptions);
        }
      }
    });
  }
  function topBarSlider() {
    const sliderWrapper = document.querySelectorAll('.top-bar__wrapper');
    sliderWrapper.forEach(wrapper => {
      if (wrapper) {
        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#slide-'+ id);
        const nextElement = wrapper.querySelector('.swiper-button-next');
        const prevElement = wrapper.querySelector('.swiper-button-prev');
        if (container) {
          if (container.swiper) {
            container.swiper.destroy();
          }
    
          let swiperOptions = {
            effect: "slide",
            grabCursor: true,
            slidesPerView: 1,
            loop: true,
            speed: 1000,
            navigation: {
              nextEl: nextElement,
              prevEl: prevElement,
            },
          };
          let swiper = new Swiper(container, swiperOptions);
        }
      }
    });
  }
  function trustpilotReviewsSlider() {
    const sliderWrapper = document.querySelectorAll('.trustpilot__slider--container');
    sliderWrapper.forEach(wrapper => {
      if (wrapper) {
        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#slide-'+ id);
        const nextElement = wrapper.querySelector('.feature__next-button');
        const prevElement = wrapper.querySelector('.feature__prev-button');
        if (container) {
          if (container.swiper) {
            container.swiper.destroy();
          }
    
          let swiperOptions = {
            effect: "slide",
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 24,
            slidesPerGroupSkip: 1,
            speed: 1000,
            loop: true,
            keyboard: {
              enabled: true,
            },
            navigation: {
              nextEl: nextElement,
              prevEl: prevElement,
            },
            breakpoints: {
              600: {
                slidesPerView: 2,
                slidesPerGroupSkip: 2,
              },
              850: {
                slidesPerView: 3,
                slidesPerGroupSkip: 3,
              },
              1050: {
                slidesPerView: 4,
                slidesPerGroupSkip: 4,
              },
            },
          };
          let swiper = new Swiper(container, swiperOptions);
        }
      }
    });
  }
  function productInfoTabs() {
    const tabLinks = document.querySelectorAll('.tab-link');
    const tabPanels = document.querySelectorAll('.tab-panel');
  
    tabLinks.forEach((btn) => {
      if (btn) {
        btn.addEventListener('click', function () {
          const tabId = this.getAttribute('data-tab');
    
          tabLinks.forEach((b) => b.classList.remove('active'));
          tabPanels.forEach((panel) => panel.classList.remove('active'));
    
          this.classList.add('active');
          document.querySelector('.tab-panel[data-tab="' + tabId + '"]').classList.add('active');
        });
      }
    });
  }
  function productZoomPopupSlider() {
    const popupWrapper = document.querySelectorAll('.product__zoom-gallery');
    popupWrapper.forEach(wrapper => {
      if (wrapper) {
        const id = wrapper.dataset.sectionId;
        const sliderContainer = wrapper.querySelector('#product__zoom-'+ id);
        const prevButton = wrapper.querySelector('.pagination__btn-prev');
        const nextButton = wrapper.querySelector('.pagination__btn-next');
        const pagination = wrapper.querySelector('.pagination__text');
        if(sliderContainer.swiper){
          sliderContainer.swiper.destroy();
        }
        let swiperOptions = {
          slidesPerView: 1,
          speed: 1000,
          loop: true,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton
          },
          pagination: {
            el: pagination,
            type: "fraction",
          },
        }
        popupSwiper[id] = new Swiper(sliderContainer, swiperOptions);
      }
      
    });
  }
  function initProductZoomListeners() {
    const productPopupBtn = document.querySelectorAll('.product-gallery__zoom button');
    const popupCloseBtn = document.querySelectorAll('.product__zoom-gallery .close__modal');
    const galleryPopup = document.querySelector('.product__zoom-gallery');
    
    productPopupBtn.forEach(button => {
      if (button) {
        button.addEventListener('click', () => {
          const mediaId = button.dataset.mediaId;
          if (galleryPopup) {
            galleryPopup.classList.add('popup__active');
          }
          const slide = galleryPopup.querySelector(`.product__popup [data-media-id="${mediaId}"]`);
          if (slide) {
            const index = slide.dataset.index;
            const sectionId = galleryPopup.dataset.sectionId;
            const popupSlider = popupSwiper[sectionId];
            popupSlider.slideTo(index - 1);
          }
        });
      }
      
    });
    popupCloseBtn.forEach(button => {
      if (button) {
        button.addEventListener('click', () => {
          galleryPopup.classList.remove('popup__active');
        });
      }
    });
  }
  function cartPageListeners() {
    document.querySelectorAll('.quantity-input').forEach(input => {
      if (input) {
        input.addEventListener('change', function () {
          const quantity = parseInt(this.value, 10);
          const lineIndex = parseInt(this.dataset.lineIndex, 10) + 1;
  
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify({
              id: this.dataset.lineKey || lineIndex,
              quantity: quantity
            })
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not OK');
            }
            return response.json();
          })
          .then(data => {
            window.location.reload();
          })
          .catch(error => {
            console.error('Cart update failed:', error);
          });
        });
      }
    });
  }
  function frequentlyCollapsabletabs() {
    const tabHeading  = document.querySelectorAll('.faq-accordion__button');
    tabHeading.forEach(tab => {
      if (tab) {
        tab.addEventListener('click', () => {
          tab.classList.toggle('collapsed');
          tab.closest('.faq__accordion-block').querySelector('.faq-accordion__content').classList.toggle('show');
        });
      }
    });
  }
  function collectionDescriptionEvents() {
    const readMoreBtn = document.querySelector('.custom-btn__container .read-more-btn');
    const readLessBtn = document.querySelector('.custom-btn__container .read-less-btn');
    const descriptionContainer = document.querySelector('.custom-description__container');
    if(readMoreBtn) {
      readMoreBtn.addEventListener('click', () => {
        descriptionContainer.classList.add('expand');
        readMoreBtn.style.display = 'none';
        readLessBtn.style.display = 'flex';
      });
    }
    if(readLessBtn) {
      readLessBtn.addEventListener('click', () => {
        descriptionContainer.classList.remove('expand');
        readMoreBtn.style.display = 'flex';
        readLessBtn.style.display = 'none';
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    initTransparentHeader();
    reviewsCounter();
    featureCollectionSlider();
    collectionListSlider();
    localizations();
    customCursor();
    headerNavigationDrawer();
    initMediaGallery();
    initStickyAddCart();
    initProductVariants();
    initFrequentProductVariants();
    cartCountdownEvents();
    initProductForm();
    collectionSorting();
    collectionFilters();
    accordions();
    initProductRecommendations();
    initCartForm();
    testimonialSlider();
    imageTextScrollingSlider();
    showMoreProducts();
    initHeaderSearch();
    predictiveSearchTabs();
    logoListSlider();
    topBarSlider();
    trustpilotReviewsSlider();
    productInfoTabs();
    productZoomPopupSlider();
    initProductZoomListeners();
    cartPageListeners();
    frequentlyCollapsabletabs();
    collectionDescriptionEvents();
  });
})();